import {QUERY_KEYS} from '@/features/goal/queries/keys.ts'
import {getHostGoals} from '@/features/goal/services/goal.http.ts'
import {useQuery} from '@tanstack/react-query'

export const useGoalsListOfUserV3 = (userID: string | number | undefined) => {
    return useQuery({
        queryKey: [QUERY_KEYS.hostGoals, userID],
        queryFn: () => getHostGoals({hostID: userID!.toString()}),
        enabled: !!userID
    })
}
